import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'HelpDesk Pro' },
    created_at: 1736033561,
    description:
      'Uma assistente de IA avançada, criada para melhorar o suporte ao cliente com automação de fluxos de trabalho e respostas instantâneas.',
    id: 4,
    name: 'Gênio do Suporte',
  },
  {
    account_id: 3,
    config: { product_name: 'CRM Tools' },
    created_at: 1736033562,
    description:
      'Ajuda a otimizar o gerenciamento de relacionamento com clientes, organizando contatos, automatizando acompanhamentos e oferecendo insights.',
    id: 5,
    name: 'Assistente de CRM',
  },
  {
    account_id: 4,
    config: { product_name: 'SalesFlow' },
    created_at: 1736033563,
    description:
      'Otimiza seu funil de vendas acompanhando leads, prevendo vendas e automatizando tarefas administrativas.',
    id: 6,
    name: 'Bot de Vendas',
  },
  {
    account_id: 5,
    config: { product_name: 'TicketMaster AI' },
    created_at: 1736033564,
    description:
      'Automatiza a atribuição e categorização de tickets, além das respostas às dúvidas dos clientes, para aumentar a eficiência do suporte.',
    id: 7,
    name: 'Bot de Tickets',
  },
  {
    account_id: 6,
    config: { product_name: 'FinanceAssist' },
    created_at: 1736033565,
    description:
      'Fornece análises financeiras, relatórios e insights para ajudar as equipes a tomar decisões orientadas por dados.',
    id: 8,
    name: 'Especialista Financeira',
  },
  {
    account_id: 8,
    config: { product_name: 'HR Assistant' },
    created_at: 1736033567,
    description:
      'Simplifica operações de RH, incluindo gestão de colaboradores, folha de pagamento e processos de recrutamento.',
    id: 10,
    name: 'Assistente de RH',
  },
];

export const documentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: 'Assistente Pro' },
    content:
      'Guia completo sobre como usar filtros de conversa para gerenciar chats com eficiência.',
    created_at: 1736143272,
    external_link:
      'https://lumiajus.com.br/hc/user-guide/articles/1677688192-how-to-use-conversation-filters',
    id: 3059,
    name: 'Como usar filtros de conversa? | Guia do usuário | lumiajus.com.br',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: 'Gênio do Suporte' },
    content:
      'Guia passo a passo para automatizar a atribuição de tickets e melhorar o fluxo de suporte no Chatwoot.',
    created_at: 1736143273,
    external_link:
      'https://lumiajus.com.br/hc/user-guide/articles/1677688200-automating-ticket-assignments',
    id: 3060,
    name: 'Automatizando a atribuição de tickets | Guia do usuário | lumiajus.com.br',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: 'Assistente de CRM' },
    content:
      'Um guia detalhado sobre como gerenciar e organizar perfis de clientes para melhorar o relacionamento.',
    created_at: 1736143274,
    external_link:
      'https://lumiajus.com.br/hc/user-guide/articles/1677688210-managing-customer-profiles',
    id: 3061,
    name: 'Gerenciando perfis de clientes | Guia do usuário | lumiajus.com.br',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: 'Bot de Vendas' },
    content:
      'Aprenda a otimizar o acompanhamento de vendas e melhorar suas previsões usando recursos avançados.',
    created_at: 1736143275,
    external_link:
      'https://lumiajus.com.br/hc/user-guide/articles/1677688220-sales-tracking-guide',
    id: 3062,
    name: 'Guia de acompanhamento de vendas | Guia do usuário | lumiajus.com.br',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: 'Bot de Tickets' },
    content:
      'Como criar, gerenciar e resolver tickets com eficiência no Chatwoot.',
    created_at: 1736143276,
    external_link:
      'https://lumiajus.com.br/hc/user-guide/articles/1677688230-managing-tickets',
    id: 3063,
    name: 'Gerenciando tickets | Guia do usuário | lumiajus.com.br',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: 'Especialista Financeira' },
    content:
      'Guia detalhado sobre como usar ferramentas de relatórios financeiros e gerar análises valiosas.',
    created_at: 1736143277,
    external_link:
      'https://lumiajus.com.br/hc/user-guide/articles/1677688240-financial-reporting',
    id: 3064,
    name: 'Relatórios financeiros | Guia do usuário | lumiajus.com.br',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer:
      'O Messenger pode estar desativado porque você está no plano gratuito ou porque o limite de caixas de entrada foi atingido.',
    created_at: 1736283330,
    id: 87,
    question: 'Por que meu Messenger no Chatwoot está desativado?',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033280,
      description: 'Ajuda com dúvidas gerais e problemas do sistema.',
      id: 1,
      name: 'Assistente 2',
    },
  },
  {
    account_id: 2,
    answer:
      'Você pode integrar sua conta do WhatsApp acessando a seção Integrações e selecionando a opção de integração com o WhatsApp.',
    created_at: 1736283340,
    id: 88,
    question: 'Como integro o WhatsApp ao Chatwoot?',
    assistant: {
      account_id: 2,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033281,
      description: 'Ajuda com dúvidas relacionadas a integrações e configuração.',
      id: 2,
      name: 'Assistente 3',
    },
  },
  {
    account_id: 3,
    answer:
      "Para redefinir sua senha, vá até a página de login, clique em 'Esqueci minha senha' e siga as instruções enviadas para seu e-mail.",
    created_at: 1736283350,
    id: 89,
    question: 'Como posso redefinir minha senha no Chatwoot?',
    assistant: {
      account_id: 3,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033282,
      description: 'Cuida de suporte para gestão e recuperação de contas.',
      id: 3,
      name: 'Assistente 4',
    },
  },
  {
    account_id: 4,
    answer:
      "Você pode ativar o modo escuro nas configurações acessando 'Aparência' e selecionando 'Modo escuro'.",
    created_at: 1736283360,
    id: 90,
    question: 'Como ativo o modo escuro no Chatwoot?',
    assistant: {
      account_id: 4,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033283,
      description: 'Ajuda com dúvidas relacionadas à interface e ao tema.',
      id: 4,
      name: 'Assistente 5',
    },
  },
  {
    account_id: 5,
    answer:
      "Para adicionar um novo membro à equipe, vá em 'Configurações', depois em 'Equipe' e clique em 'Adicionar membro à equipe'.",
    created_at: 1736283370,
    id: 91,
    question: 'Como adiciono um novo membro à equipe no Chatwoot?',
    assistant: {
      account_id: 5,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033284,
      description: 'Ajuda com dúvidas sobre gestão de equipes e acesso de usuários.',
      id: 5,
      name: 'Assistente 6',
    },
  },
  {
    account_id: 6,
    answer:
      "As campanhas no Chatwoot permitem enviar mensagens direcionadas para segmentos específicos de usuários. Você pode criá-las na seção 'Campanhas'.",
    created_at: 1736283380,
    id: 92,
    question: 'O que são campanhas no Chatwoot?',
    assistant: {
      account_id: 6,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033285,
      description:
        'Especializada em marketing, gestão de campanhas e estratégias de comunicação.',
      id: 6,
      name: 'Assistente 7',
    },
  },
];

export const inboxes = [
  {
    id: 7,
    name: 'Suporte por e-mail',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    name: 'Chat do site',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Suporte no Facebook',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: 'Serviço de SMS',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'Suporte no WhatsApp',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+1987654321',
  },
  {
    id: 8,
    name: 'Suporte no Telegram',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'Suporte no LINE',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'Canal de API',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: 'SMS básico',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];
